<div class="content">
    <svg-icon key="panel"></svg-icon>
    <div class="error-title">{{errorTitle}}</div>
    <nts-filled-button [type]="1" [title]="'std_Retry' | NTSTranslate"
        [label]="'std_Retry' | NTSTranslate" (onClicked)="retry()">
    </nts-filled-button>
</div>
